import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { html_beautify as htmlBeautify } from 'js-beautify';
import Button from '../../components/Button';
import { footerContent, wrapAssetMarkup, wrapTileMarkup } from './util';
import DemoUserActionLinkTiles from '../../components/ActionLinkTile/demoUserActionLinkTiles';
import HcpUserActionLinkTiles from '../../components/ActionLinkTile/hcpUserActionLinkTiles';
import { renderToStaticMarkup } from '../../utils/renderToStaticMarkup';
import { peerChallengeShape } from '../../components/PeerChallenge/shared/types';
import Tile from './tile';
import PChallengeContent from './content';
import { MainContent } from '../../components/PeerChallenge/MainContent';

// function for creating file in memory
function download(filename, href) {
    const element = document.createElement('a');
    // eslint-disable-next-line prefer-template
    element.setAttribute('href', href);
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

const PeerChallengePreviewAdmin = ({
    fetchPeerChallenge, resourceId, resourceStatus, resource,
}) => {
    const [errorText, setErrorText] = useState();

    useEffect(() => {
        if (resourceId && resourceStatus) {
            fetchPeerChallenge(resourceId, resourceStatus, setErrorText);
        }
    }, [resourceId, resourceStatus]);

    const handleGenerateChallenge = () => {
        const html = renderToStaticMarkup(<MainContent resourceId={resourceId} peerChallengeData={resource} />);

        const footer = footerContent(
            renderToStaticMarkup(<DemoUserActionLinkTiles />),
            renderToStaticMarkup(<HcpUserActionLinkTiles />),
        );

        const assetMarkup = wrapAssetMarkup(html, footer);

        const beautified = htmlBeautify(assetMarkup);
        const href = `data:text/plain;charset=utf-8,${encodeURIComponent(beautified)}`;

        download(`Peer-Challenge-${resourceId}.php`, href);
    };

    const handleGenerateTile = () => {
        const { programId, assetId, ProgramTile } = resource;

        const html = renderToStaticMarkup(<Tile
            programId={programId}
            assetId={assetId}
            backgroundImage={ProgramTile.backgroundImage}
            ctaUrl={ProgramTile.ctaUrl}
        />);

        const tileMarkup = wrapTileMarkup(html);
        const beautified = htmlBeautify(tileMarkup);
        const href = `data:text/plain;charset=utf-8,${encodeURIComponent(beautified)}`;

        download(`PC-Tile-${resourceId}.php`, href);
    };

    if (!resource && !errorText) {
        return null;
    }

    if (errorText) {
        return (
            <div>
                {errorText}
            </div>
        );
    }

    const { programId, assetId, ProgramTile } = resource;

    return (
        <div className="challenge-preview-container">
            {ProgramTile &&
                <Fragment>
                    <div className="export-challenge-container">
                        <Button onClick={handleGenerateTile}>Export Tile</Button>
                    </div>
                    <Tile
                        programId={programId}
                        assetId={assetId}
                        title={ProgramTile.title}
                        ctaText={ProgramTile.CtaText}
                        image={ProgramTile.Image}
                        backgroundImage={ProgramTile.backgroundImage}
                        ctaUrl={ProgramTile.ctaUrl}
                    />
                </Fragment>
            }
            <div className="export-challenge-container">
                <Button className="export-challenge" onClick={handleGenerateChallenge}>Export Peer Challenge</Button>
            </div>
            <PChallengeContent resourceId={resourceId} resource={resource} />
        </div>
    );
};

PeerChallengePreviewAdmin.propTypes = {
    resourceId: PropTypes.string,
    resourceStatus: PropTypes.string,
    resource: PropTypes.shape({ data: peerChallengeShape }),
    fetchPeerChallenge: PropTypes.func.isRequired,
};

PeerChallengePreviewAdmin.defaultProps = {
    resourceId: null,
    resourceStatus: 'published',
    resource: null,
};


export default PeerChallengePreviewAdmin;
